import PropTypes from 'prop-types';
import React from 'react';
import CustomSelect from "./CustomSelect";

const NumberSelect = ({
                        disabled, value, className, setValue, label, max = 5, options
                      }) => {
  const _options = options ? options.map((val) => ({
    value: val,
    label: val
  })) : Array.from({length: max}, (_, i) => ({value: i + 1, label: i + 1}));

  return (

    <CustomSelect onChange={setValue} value={value} title={label} titleClass="text-xs pl-2"
                  options={_options} disabled={disabled}
                  className={className}/>
  );
};


NumberSelect.propTypes = {
  className: PropTypes.string,
  setValue: PropTypes.func.isRequired,

};

export default NumberSelect;

